import ModuleConfig from './Module.config.json'
import { SimulationModule, ModuleContent, ElectricalCode, FaultMode } from './Types'
import ContentNEC from './content.json'
import ContentIEC from './content-iec.json'
import { getElectricalCode } from './App.config'
import { ModuleClass } from './ModuleTypes'

export const simMod = {
    isLab: ModuleConfig.type === ModuleClass.LL,
    isTS: ModuleConfig.type === ModuleClass.TS,
    ...ModuleConfig
} as SimulationModule

export const moduleContent: ModuleContent =
    getElectricalCode() === ElectricalCode.IEC
        ? (ContentIEC as ModuleContent)
        : (ContentNEC as ModuleContent)

export const getFaultMessage = (faultMode: FaultMode | undefined) => {
    let popupBody: string = ''
    if (simMod.faultModeMessage && faultMode) {
        switch (faultMode) {
            case FaultMode.Explore:
                popupBody = simMod.faultModeMessage.explore
                break

            case FaultMode.Troubleshoot:
                popupBody = simMod.faultModeMessage.troubleshoot
                break

            default:
                popupBody = simMod.faultModeMessage.explore
                break
        }
    }

    return popupBody
}